import { useState, useCallback } from 'react';

export type SortField = 'createdAt' | 'updatedAt';
export type SortDirection = 'asc' | 'desc';

export interface ReportSortOption {
    field: SortField;
    direction: SortDirection;
}

export const REPORT_SORT_OPTIONS: {
    id: string;
    field: SortField;
    direction: SortDirection;
    labelKey: string;
}[] = [
    {
        id: 'createdAt-desc',
        field: 'createdAt',
        direction: 'desc',
        labelKey: 'sort.newestCreated',
    },
    {
        id: 'createdAt-asc',
        field: 'createdAt',
        direction: 'asc',
        labelKey: 'sort.oldestCreated',
    },
    {
        id: 'updatedAt-desc',
        field: 'updatedAt',
        direction: 'desc',
        labelKey: 'sort.newestUpdated',
    },
    {
        id: 'updatedAt-asc',
        field: 'updatedAt',
        direction: 'asc',
        labelKey: 'sort.oldestUpdated',
    },
];

const DEFAULT_SORT_OPTION: ReportSortOption = {
    field: 'createdAt',
    direction: 'desc',
};

interface ReportsFiltersState {
    sortOption: ReportSortOption | null;
    setSortOption: (option: ReportSortOption | null) => void;
    getQueryParams: () => {
        orderBy?: string;
    };
}

export function useReportsFilters(): ReportsFiltersState {
    const [sortOption, setSortOption] = useState<ReportSortOption | null>(
        DEFAULT_SORT_OPTION,
    );

    const getQueryParams = useCallback(() => {
        return {
            ...(sortOption && {
                orderBy: `${sortOption.field} ${sortOption.direction}`,
            }),
        };
    }, [sortOption]);

    return {
        sortOption,
        setSortOption,
        getQueryParams,
    };
}
